import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Routes } from '../constants';

interface AuthGuardProps {
  children: ReactNode;
}

const AuthGuard = (props: AuthGuardProps) => {
  const { children } = props;
  const location = useLocation();

  const nonRestrictedUrls = [Routes.signUp, Routes.denverPnr, Routes.truckSelectLink, Routes.scSelectLinkAnalysis];

  const isNonRestrictedUrl = nonRestrictedUrls?.find((item: string) => location.pathname?.toLowerCase()?.includes(item?.toLowerCase()));

  if (localStorage.getItem('access-token') && !isNonRestrictedUrl) {
    return <Navigate to={Routes.home} />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default AuthGuard;
